import React from 'react';
import PlayBtn from '../../assets/images/play-btn.svg';

export const VideoOpenButton = () => {
  return (
    <PlayBtn className="VideoOpenButton absolute h-[102px] w-[102px] drop-shadow-playBtn transition-all duration-300 group-hover:scale-110" />
  );
};
